import React, {Fragment, memo} from "react";
import {shallowEqual, useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {mt} from "@pg-design/helpers-css";
import {AdditionalAreaIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {compact, isEmpty} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {getPropertyTagProps} from "../helpers/PropertyTags";
import {IPropertyTag} from "../types/IPropertyTag";
import {PropertyDetailTag} from "./PropertyDetailTag";

export interface IPropertyTags {
    header?: string;
    property: {
        additional_areas: {
            type: number;
            area: number;
        }[];
        offer: {
            properties: number;
            tags: IPropertyTag[];
            type: number;
        };
        price: number | null;
        tags: IPropertyTag[];
    };
}

export const PropertyDetailTags = memo(({header, property}: IPropertyTags) => {
    const theme = useTheme();

    const property_additional_areas = useSelector((state: IRPStore) => state.variables.data?.property_additional_areas, shallowEqual);

    const getPropertyTags = () => {
        if (isEmpty(property)) {
            return [];
        }

        const tags = compact([...(property.tags || []), ...(property.offer.tags || [])].map((tag) => getPropertyTagProps(tag, property)));

        if (!isEmpty(property.additional_areas) && !isEmpty(property_additional_areas)) {
            const additionalAreas = compact(
                property.additional_areas.reduce<(string | null)[]>((acc, area) => {
                    acc.push(property_additional_areas?.find(({value}) => value === area.type)?.label || null);
                    return acc;
                }, [])
            );

            if (!isEmpty(additionalAreas)) {
                tags.push({
                    label: "Pow. dodatkowe",
                    icon: AdditionalAreaIcon,
                    value: additionalAreas.join(", ")
                });
            }
        }

        return tags;
    };

    const propertyTags = getPropertyTags();

    if (isEmpty(propertyTags)) {
        return null;
    }

    return (
        <Fragment>
            {header && (
                <Text as="h2" variant="headline_4">
                    {header}
                </Text>
            )}

            <div css={propertyTagsWrapper}>
                {propertyTags.map(({icon: Icon, ...rest}, index) => (
                    <PropertyDetailTag key={index} {...rest} icon={<Icon size="3" wrapperColor={theme.colors.primary} wrapperSize="4.8" />} />
                ))}
            </div>
        </Fragment>
    );
});

const propertyTagsWrapper = (theme: Theme) => css`
    display: flex;
    align-items: flex-start;
    column-gap: 2.4rem;

    width: 100%;
    ${mt(4)};

    @media (max-width: ${theme.breakpoints.md}) {
        flex-direction: column;
    }
`;
import React, {Fragment, memo} from "react";
import {shallowEqual, useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {mt} from "@pg-design/helpers-css";
import {AdditionalAreaIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {compact, isEmpty} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {getPropertyTagProps} from "../helpers/PropertyTags";
import {IPropertyTag} from "../types/IPropertyTag";
import {PropertyDetailTag} from "./PropertyDetailTag";

export interface IPropertyTags {
    header?: string;
    property: {
        additional_areas: {
            type: number;
            area: number;
        }[];
        offer: {
            properties: number;
            tags: IPropertyTag[];
            type: number;
        };
        price: number | null;
        tags: IPropertyTag[];
    };
}

export const PropertyDetailTags = memo(({header, property}: IPropertyTags) => {
    const theme = useTheme();

    const property_additional_areas = useSelector((state: IRPStore) => state.variables.data?.property_additional_areas, shallowEqual);

    const getPropertyTags = () => {
        if (isEmpty(property)) {
            return [];
        }

        const tags = compact([...(property.tags || []), ...(property.offer.tags || [])].map((tag) => getPropertyTagProps(tag, property)));

        if (!isEmpty(property.additional_areas) && !isEmpty(property_additional_areas)) {
            const additionalAreas = compact(
                property.additional_areas.reduce<(string | null)[]>((acc, area) => {
                    acc.push(property_additional_areas?.find(({value}) => value === area.type)?.label || null);
                    return acc;
                }, [])
            );

            if (!isEmpty(additionalAreas)) {
                tags.push({
                    label: "Pow. dodatkowe",
                    icon: AdditionalAreaIcon,
                    value: additionalAreas.join(", ")
                });
            }
        }

        return tags;
    };

    const propertyTags = getPropertyTags();

    if (isEmpty(propertyTags)) {
        return null;
    }

    return (
        <Fragment>
            {header && (
                <Text as="h2" variant="headline_4">
                    {header}
                </Text>
            )}

            <div css={propertyTagsWrapper}>
                {propertyTags.map(({icon: Icon, ...rest}, index) => (
                    <PropertyDetailTag key={index} {...rest} icon={<Icon size="3" wrapperColor={theme.colors.primary} wrapperSize="4.8" />} />
                ))}
            </div>
        </Fragment>
    );
});

const propertyTagsWrapper = (theme: Theme) => css`
    display: flex;
    align-items: flex-start;
    column-gap: 2.4rem;

    width: 100%;
    ${mt(4)};

    @media (max-width: ${theme.breakpoints.md}) {
        flex-direction: column;
    }
`;
